query personAttributeFieldValues(
  $attributeType: String!
  $subtype: String
  $search: String
  $limit: Int = 10
) {
  values: personAttributeFieldValues(
    attributeType: $attributeType
    subtype: $subtype
    search: $search
    limit: $limit
  )
}
